import { FormattedMessage } from 'react-intl';

import { useSearchParameter } from '@xing-com/crate-hooks-use-search-parameter';
import { SEARCH_STATE_PARAMS } from '@xing-com/crate-jobs-constants';
import { useSearchState } from '@xing-com/crate-jobs-hooks';
import { DeleteTag } from '@xing-com/tag';

export const SinceTag: React.FC = () => {
  const { since } = useSearchState();
  const { deleteSearchParameter } = useSearchParameter();

  const onClick = (): void => {
    deleteSearchParameter(SEARCH_STATE_PARAMS.since, { replace: false });
  };

  return since ? (
    <DeleteTag onClick={onClick} onDelete={onClick} selected>
      <FormattedMessage id="JOBS_SEARCH_FILTER_SINCE_VALUE" />
    </DeleteTag>
  ) : null;
};
